import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as colors from '#app/constants/Color';
import Overlay from '#components/Elements/Overlay/Overlay';

// eslint-disable-next-line import/namespace
const colorMap = [null].concat(Object.keys(colors).map((key) => colors[key]));

export default class Input extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    style: PropTypes.shape({}),
    type: PropTypes.oneOf([
      'text',
      'date',
      'email',
      'tel',
      'password',
      'number',
      'search',
      'time',
    ]),
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    state: PropTypes.oneOf(['hovered', 'focused', 'active', 'loading']),
    color: PropTypes.oneOf(colorMap),
    readOnly: PropTypes.bool,
    autoFocus: PropTypes.bool,
    isStatic: PropTypes.bool,
    isRounded: PropTypes.bool,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    defaultValue: PropTypes.string,
    inputSuffix: PropTypes.node,
    suffixIcons: PropTypes.bool,
    autoComplete: PropTypes.string,
    disableAutocomplete: PropTypes.bool,
    disableOnFocus: PropTypes.bool,
  };

  static defaultProps = {
    className: '',
    value: '',
    style: {},
    type: 'text',
    size: null,
    state: null,
    color: null,
    readOnly: false,
    autoFocus: false,
    isStatic: false,
    isRounded: false,
    disabled: false,
    placeholder: '',
    name: null,
    onChange: null,
    onFocus: null,
    onBlur: null,
    defaultValue: '',
    inputSuffix: null,
    suffixIcons: false,
    autoComplete: null,
    disableAutocomplete: false,
    disableOnFocus: false,
  };

  componentDidMount() {
    const { autoFocus } = this.props;
    if (autoFocus) {
      this.focus();
    }
  }

  focus = () => {
    this.input.focus();
  };

  blur = () => {
    this.input.blur();
  };

  get contentWidth() {
    return this.inputContent?.clientWidth || 0;
  }

  onChange = (e) => {
    const { onChange } = this.props;
    onChange?.(e);
  };

  render() {
    const {
      type,
      size,
      state,
      name,
      color,
      value,
      readOnly,
      isStatic,
      disabled,
      className,
      autoFocus,
      isRounded,
      placeholder,
      defaultValue,
      inputSuffix,
      suffixIcons,
      autoComplete,
      disableAutocomplete,
      disableOnFocus,
      onBlur,
      onFocus,
      ...props
    } = this.props;
    const renderValue = value || defaultValue;
    return (
      <Overlay>
        <input
          {...props}
          {...(!disableOnFocus && { onFocus: onFocus, onBlur: onBlur })}
          ref={(node) => {
            this.input = node;
          }}
          autoComplete={autoComplete || (disableAutocomplete ? 'off' : 'on')}
          name={name}
          value={renderValue}
          type={type}
          placeholder={placeholder}
          readOnly={readOnly || isStatic}
          disabled={disabled}
          autoFocus={autoFocus}
          onChange={this.onChange}
          className={classnames('input', className, {
            'is-static': isStatic,
            'is-rounded': isRounded,
            [`is-${size}`]: size,
            [`is-${state}`]: state,
            [`is-${color}`]: color,
          })}
        />
        {!!inputSuffix && (
          <span
            className={classnames('input-suffix', {
              'suffix-icons': suffixIcons,
            })}
            ref={(node) => {
              this.inputContent = node;
            }}
          >
            {inputSuffix}
          </span>
        )}
      </Overlay>
    );
  }
}
